import { apiRequest } from './apiClient.js';

export const authService = {
    getStatus() {
        return apiRequest('/auth/telegram/status');
    },
    initiate() {
        return apiRequest('/auth/telegram/initiate', { method: 'POST' });
    },
    verifyCode(code) {
        return apiRequest('/auth/telegram/code', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ code }),
        });
    },
    createTempToken() {
        return apiRequest('/auth/create-temp-token', { method: 'POST' });
    },
};
